import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  as?: 'div' | 'section' | 'article' | 'li';
  raised?: boolean;
  children: ReactNode;
}

export function Card({ as = 'div', raised = false, className, children, ...rest }: CardProps) {
  const Tag = as as 'div';
  return (
    <Tag
      className={cx(
        'rounded-xl border border-line-subtle bg-surface p-5',
        raised ? 'shadow-card-raised' : 'shadow-card',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function CardHeader({
  title,
  action,
  eyebrow,
}: {
  title: ReactNode;
  action?: ReactNode;
  eyebrow?: string;
}) {
  return (
    <div className="mb-4 flex items-start justify-between gap-4">
      <div>
        {eyebrow && <p className="eyebrow mb-1">{eyebrow}</p>}
        <h2 className="font-display text-[21px] font-semibold leading-tight text-ink">{title}</h2>
      </div>
      {action}
    </div>
  );
}
